<template>
  <section class="layout-section">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Grille à puces</h2>
      <p>
        Une grille en trois colonnes permet une lecture fluide. L’icône attire l’attention, le titre facilite le
        repérage, et le court texte donne juste assez d’information pour éveiller l’intérêt.
      </p>
    </div>

    <article class="layout-grid">
      <section class="layout-grid__item -third">
        <figure class="grid-bullet__figure">
          <SvgIcon id="content-education" />
        </figure>

        <h3 class="grid-bullet__title">Défendre le droit à l’éducation</h3>
        <p>Nous contribuons à la promotion de l’apprentissage tout au long de la vie pour tous les adultes.</p>
      </section>

      <section class="layout-grid__item -third">
        <figure class="grid-bullet__figure -accent">
          <SvgIcon id="bullet-2" />
        </figure>

        <h3 class="grid-bullet__title">Mobiliser la société civile</h3>
        <p>Nous soutenons la concertation des organisations afin d’influencer les politiques publiques en éducation.</p>
      </section>

      <section class="layout-grid__item -third">
        <figure class="grid-bullet__figure -neutral">
          <SvgIcon id="bullet-3" />
        </figure>

        <h3 class="grid-bullet__title">Valoriser l’engagement</h3>
        <p>Nous reconnaissons la persévérance des adultes en formation et encourageons des projets innovants.</p>
      </section>
    </article>
  </section>
</template>

<script>
export default {
  name: 'DemoGridBullet'
}
</script>
